import { GlobeLight } from '@octopus-do/octopus-storybook/icons'
import { removeExternalLinkImage } from '@storeOld/reducers/externalLinks'
import { useDispatch } from 'react-redux'

import css from './Image.module.scss'

type Props = {
  id: string
  image?: string | null
  title?: string | null
}

const Image: React.FC<Props> = ({ id, image, title }) => {
  const dispatch = useDispatch()

  const onError = () => {
    dispatch(removeExternalLinkImage(id))
  }

  if (!image) {
    return (
      <div className={css.fallback}>
        <GlobeLight className={css.fallback_icon} />
      </div>
    )
  }

  return (
    <div className={css.container}>
      <img
        className={css.img}
        src={image}
        alt={title || ''}
        onError={onError}
      />
    </div>
  )
}

export default Image
